import { InfoOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import AppTable from "components/Shared/AppTable";
import TableFilter from "components/Shared/AppTable/TableFilter";
import { BaseTabs } from "components/Shared/BaseTabs";
import HighlightedText from "components/Shared/HighlightedText";
import { useAppMeta, useTablePagination } from "hooks";
import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLazyGetContractorUserListDataQuery } from "store/services/contractorUserApi";

const ContractorUserListScreen = () => {
  const { currentPage, perPage, handlePageChange, handlePerRowsChange } = useTablePagination();
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "Active";
  const keyword = searchParams.get("search") || "";

  const breadcrumbs = [{ title: "Contractor" }];

  const contractorListTabs = [
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
  ];

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      cell: (row) => (
        <Link
          title={row?.name}
          to={`/app/crm/contractorUser/${row._id}/detail`}
          className="line-clamp-2 hover:text-blue-600 hover:underline dark:hover:text-blue-300"
        >
          {row?.name ? <HighlightedText text={row?.name} highlight={keyword} /> : "N/A"}
        </Link>
      ),
      sortable: true,
    },
    {
      name: "User ID",
      selector: (row) => row.contractorUserID,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
      sortable: true,
    },
    {
      name: "Alternate Phone",
      selector: (row) => row.alternatePhone,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="flex items-center gap-1">
          <Link to={`/app/crm/contractorUser/${row._id}/detail`}>
            <Tooltip title="View Contractor User Detail" arrow>
              <IconButton size="small" aria-label="View contractor user" color="primary">
                <InfoOutlined />
              </IconButton>
            </Tooltip>
          </Link>
          {/* <Link to={`/app/crm/contractorUser/${row._id}/edit`} state={{ from: "list" }}>
            <Tooltip title="Edit Contractor User" arrow>
              <IconButton size="small" aria-label="Edit contractor user">
                <ModeEditOutlineTwoTone />
              </IconButton>
            </Tooltip>
          </Link> */}
        </div>
      ),
      ignoreRowClick: true,
      right: true,
    },
  ];

  const [
    fetchContractorUsers,
    {
      data: contractorUserRes,
      isLoading: loadingContractorUsers,
      isFetching: fetchingContractorUsers,
      error,
    },
  ] = useLazyGetContractorUserListDataQuery();

  React.useEffect(() => {
    fetchContractorUsers({
      active: activeTab === "Active",
      page: currentPage,
      limit: perPage,
      ...(keyword && { search: keyword }),
    });
  }, [activeTab, currentPage, perPage, keyword, fetchContractorUsers]);

  useAppMeta(`${activeTab} ContractorUser`);

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} headerActions={<PageActions />}>
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <BaseTabs tabs={contractorListTabs} defaultValue={activeTab} />
        <TableFilter searchLabel="Name" disabled={loadingContractorUsers || fetchingContractorUsers}>
        </TableFilter>

        <AppTable
          columns={columns}
          data={contractorUserRes?.data ?? []}
          progressPending={loadingContractorUsers || fetchingContractorUsers}
          paginationServer
          paginationPerPage={perPage}
          paginationTotalRows={contractorUserRes?.totalItems ?? 0}
          paginationDefaultPage={currentPage}
          onChangePage={handlePageChange}
          onChangeRowsPerPage={handlePerRowsChange}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default ContractorUserListScreen;

const PageActions = () => {
  return (
    <>
    {/* <Link to="/app/crm/contractorUser/create">
      <Button startIcon={<Add />} variant="contained">
        New Contractor
      </Button>
    </Link> */}
    </>
  );
};
